import { useTranslations } from 'next-intl';
import { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useSWRConfig } from 'swr';


import { limit } from '@components/Article/Comments';
import Button from '@components/Form/Button';
import Loader from '@components/root/Loader';
import { Link } from '@lib/navigation';
import { logger } from '@logger';
import { useUserStore } from '@utils/user';

type Props = {
  postId: number;
  parentId?: number;
  option?: 'main' | 'answer';
  hideAddComment: () => void;
};
const AddComment = ({ postId, parentId = 0, hideAddComment }: Props) => {
  const { mutate } = useSWRConfig();
  const [commentValue, setCommentValue] = useState<string>('');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [captcha, setCaptcha] = useState<boolean>(false);
  const notify = { error: alert };
  const userStore = useUserStore();
  const t = useTranslations();
  const recaptchaRef = useRef();

  const handleCaptcha = () => {
    logger.warn('handleCaptcha');
  };

  const onFormSubmit = async (e) => {
    e.preventDefault();
    if (!userStore.isLoggedIn) {
      alert('user is not logged in');
      return;
    }

    setLoading(true);

    try {
      await fetch(`${process.env.NEXT_PUBLIC_API_PUBLIC}/comments/create/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userStore.accessToken}`,
        },
        body: JSON.stringify({
          content: commentValue,
          post: postId,
          parent: parentId,
        }),
      });
      // timeout to allow the pipelines to pass in the comment to elastic
      setTimeout(() => {
        mutate(`/comments/${postId}?limit=${limit}`);
        hideAddComment();
        setCommentValue('');
      }, 1000);
    } catch (e) {
      // @ts-expect-error -- caught error is untyped
      switch (e?.response.status) {
        case 409:
          notify.error(t('main.message.errors.commentDuplicate'));
          break;
        default:
          notify.error(t('main.message.errors.commentFailure'));
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div data-test="comment.add.wrapper">
      {isLoading && <Loader delay={0} />}
      <form onSubmit={(e) => onFormSubmit(e)}>
        <div className="">
          {/* <Input name="comment" > */}
          <div className="">
            <textarea
              className="w-full rounded-md border border-gray-300 p-2"
              data-test="comment.add.text"
              placeholder={t('main.label.placeholder.comment')}
              value={commentValue}
              onChange={(e) => setCommentValue(e.target.value)}
              onClick={() => setCaptcha(true)}
              name="comment"
              rows={5}
            />
            <div className="flex flex-col justify-between gap-6 lg:flex-row">
              <Button className="py-1" data-test="comment.add.send">
                {t('main.label.placeholder.comment')}
              </Button>
              <Button
                type="button"
                className="py-1"
                data-test="comment.add.cancel"
                onClick={() => hideAddComment()}
              >
                {t('main.functionalities.cancel')}
              </Button>
            </div>
          </div>
          {userStore.isLoggedIn && (
            <div>
              {t('main.account.notifications.setItUp.text')}
              <Link href="/profile/notifications" data-test="comment.profile">
                {t('main.account.notifications.setItUp.link')}
              </Link>
            </div>
          )}
          <hr />
        </div>
        {captcha && (
          <ReCAPTCHA
            size="invisible"
            ref={recaptchaRef}
            sitekey={process.env.NEXT_PUBLIC_RECAPTCHA}
            onChange={() => handleCaptcha()}
          />
        )}
      </form>
    </div>
  );
};

export default AddComment;
